/* eslint-disable jsx-a11y/anchor-is-valid */

import SearchField from "components/fields/SearchField";
import { IoIosCopy } from "react-icons/io";
import { PiQuestionLight } from "react-icons/pi";
import { PiEyeLight } from "react-icons/pi";
import { MdNavigateNext, MdNavigateBefore, MdSkipPrevious, MdSkipNext } from "react-icons/md";
import { FaAngleDown } from "react-icons/fa";
import { RiWallet3Fill } from "react-icons/ri";
import { Link } from "react-router-dom";
import Dropdown from "components/dropdown";
import BTC from "assets/img/icons/btc.png";

const Address = () => {
  return (
    <div className="relative">
      {/* Card widget */}
      <div className="header-back-gradient">
        <div className="container py-6">
          <div className="w-full px-2.5 md:px-3 lg:px-5">
            <div className="w-full flex items-center ">
              <div className="md:flex justify-between w-full md:py-6 md:gap-6">
                <div className="md:mb-0 mb-4">
                  <p className="relative text-header text-white mb-3">Address</p>
                  <div className="flex gap-[2px] items-center">
                    <div className="truncateWrapper">
                      <span className="text-large truncate mr-1 text-white">
                      0x95222290DD7278Aa3Ddd389Cc1E1d165CC4BAfe5
                      </span>
                    </div>
                    <button className="text-large text-green-600"><IoIosCopy /></button>
                  </div>
                </div>
                <SearchField
                  extra="sm:min-w-[480px] xl:min-w-[650px]"
                  placeholder="Search by Address/ Txn Hash/ Block/ Token/Domain Name"
                  id="email"
                  type="text"
                />
              </div>
            </div>
            <div className="w-full flex text-center mt-3 md:mt-1">
              <div className="ml-auto md:mr-0 mr-auto flex gap-4">
                <button className="btn btn-gray text-xsmall !font-semibold flex items-center">Buy <span className="ml-[1px] text-xs"><FaAngleDown /></span></button>
                <button className="btn btn-gray text-xsmall !font-semibold flex items-center">Exchange <span className="ml-[1px] text-xs"><FaAngleDown /></span></button>
                <button className="btn btn-gray text-xsmall !font-semibold flex items-center">Play <span className="ml-[1px] text-xs"><FaAngleDown /></span></button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="mt-6 md:mt-12 px-2.5 md:px-3 lg:px-5">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="box bg-white dark:bg-darkPrimary p-5">
              <div className="flex flex-col gap-3">
                <h1 className="text-large mb-2.5">Overview</h1>
                <div className="flex justify-between">
                  <span className="text-gray-700 min-w-[100px]">BBA Balance</span>
                  <span>1,587,547.35 BBA <span className="text-gray-700">($1000.00)</span></span>
                </div>
                <div className="flex justify-between min-w-[100px]">
                  <span className="text-gray-700">Holding Tokens</span>
                  <span>$5,6587 <span className="text-gray-700">(200 Tokens)</span></span>
                </div>
                <div className="flex gap-3 items-center">
                  <Dropdown
                    extra="grow"
                    button={
                      <button className="btn-outline w-full !rounded-[6px]">
                        <div className="flex justify-between">
                        <span className="text-gray-900 dark:text-white">$5,6587 <span className="text-gray-700">(200 Tokens)</span></span>
                        <span className="text-large text-gray-700"><FaAngleDown /></span>
                        </div>
                      </button>
                    }
                    animation="origin-[50%_0%] md:origin-top-center transition-all duration-300 ease-in-out"
                    children={
                      <div className="box rounded-[7px] py-2.5 px-5 bg-white dark:bg-darkGrey1 grid grid-cols-1">
                        <SearchField
                          extra="mb-3"
                          placeholder="Search for Token Name"
                          id="email"
                          type="text"
                        />
                        <div className="grid grid-cols-2 mb-2">
                          <div>
                            <div className="flex items-center mb-1">
                              <img
                                width={16}
                                height={16}
                                className="mr-2"
                                src={BTC}
                                alt="Coin"
                              />
                              <span className="text-xsmall dark:text-white">Wrapped BTC (WBTC)</span>
                            </div>
                            <span className="text-xsmall text-gray-700 dark:text-gray-300">0.04175858 WBTC</span>
                          </div>
                          <div className="text-right">
                            <p className="mb-1 text-xsmall dark:text-white">$1,548.5</p>
                            <p className="text-xsmall text-gray-700 dark:text-gray-300">@0.997</p>
                          </div>
                        </div>
                        <div className="grid grid-cols-2 mb-2">
                          <div>
                            <div className="flex items-center mb-1">
                              <img
                                width={16}
                                height={16}
                                className="mr-2"
                                src={BTC}
                                alt="Coin"
                              />
                              <span className="text-xsmall dark:text-white">Wrapped BTC (WBTC)</span>
                            </div>
                            <span className="text-xsmall text-gray-700 dark:text-gray-300">0.04175858 WBTC</span>
                          </div>
                          <div className="text-right">
                            <p className="mb-1 text-xsmall dark:text-white">$1,548.5</p>
                            <p className="text-xsmall text-gray-700 dark:text-gray-300">@0.997</p>
                          </div>
                        </div>
                        <Link to="/portfolio/0x95222290DD7278Aa3Ddd389Cc1E1d165CC4BAfe5" className="">
                          <div className="flex items-center justify-center pt-2 border-t-[1px] border-gray-100 dark:border-lightGrey">
                              <span className="text-[24px] text-gray-700"><RiWallet3Fill /></span>
                              <span className="ml-3 dark:text-gray-300 text-xsmall">View All Holdings</span>
                          </div>
                        </Link>
                      </div>
                    }
                    classNames={"w-full mt-9"}
                  />
                  <Link to="/portfolio/0x95222290DD7278Aa3Ddd389Cc1E1d165CC4BAfe5" className="text-[24px] text-gray-700"><RiWallet3Fill /></Link>
                </div>
              </div>
            </div>
            <div className="box bg-white dark:bg-darkPrimary overflow-hidden p-5">
              <div className="flex flex-col gap-3">
                <h1 className="text-large mb-2.5">More Info</h1>
                <div className="flex justify-between">
                  <span className="text-gray-700">Public Name</span>
                  <span className="">Binance2</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-700">Owner</span>
                  <div className="flex items-center">
                    <span className="text-green-900 mr-2">System Program</span>
                    <button className="text-gray-700 dark:text-gray-300"><IoIosCopy /></button>
                  </div>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-700">Transactions Sent</span>
                  <span className="">Latest:10 secs ago</span>
                </div>
              </div>
            </div>
            <div className="box bg-white dark:bg-darkPrimary overflow-hidden p-5">
              <div className="flex flex-col gap-3">
                <h1 className="text-large mb-2.5">More Info</h1>
                <div className="flex justify-between">
                  <span className="text-gray-700">Allocated Data Size</span>
                  <span className="">0 byte(s)</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-700">Exectable</span>
                  <span className="">No</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-6 mb-12 px-2.5 md:px-3 lg:px-5">
          <div className="box bg-white dark:bg-darkPrimary overflow-hidden">
            <div className="flex flex-col mt-5">
              <div className="flex gap-1 flex-row items-center justify-between flex-wrap w-full px-2.5 md:px-5 py-4">
                <div className="not-italic text-large">
                More than 643,280,993 transactions found
                </div>
              </div>
            </div>
            <div className="table-wrapper">
              <table className="table w-full">
                <thead>
                  <tr className="">
                    <th className="w-[10px] !min-w-0 !pr-0"><a href="#" className="text-large"><PiQuestionLight /></a></th>
                    <th className="">Txn Hash</th>
                    <th className="">Block</th>
                    <th className="">Age</th>
                    <th className="">From</th>
                    <th className="">To</th>
                    <th className="">Fee (BBA)</th>
                    <th className="">Value (BBA)</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    Array(10).fill(0).map((data, index) => <tr>
                      <td className="!pr-0">
                        <a href="#" className="text-large"><PiEyeLight /></a>
                      </td>
                      <td>
                        <div className="flex gap-[1px] max-w-[160px]">
                          <div className="truncateWrapper">
                            <Link to="/txs/3FDZVJSFgGcpk5iJMfTPTVDgMwopjKfHYqq3PoZkncFsJWDFPLx9BUWWsmrnFQ2H2CmfxA61gMkrcavSdvbGyv2b" className="text-green-900 text-small truncate">
                              3FDZVJSFgGcpk5iJMfTPTVDgMwopjKfHYqq3PoZkncFsJWDFPLx9BUWWsmrnFQ2H2CmfxA61gMkrcavSdvbGyv2b
                            </Link>
                          </div>
                          <button className="text-gray-700 dark:text-gray-300"><IoIosCopy /></button>
                        </div>
                      </td>
                      <td>
                        <p className="text-small text-green-900">109,901,461</p>
                      </td>
                      <td>
                        <p className="text-small">12 secs ago</p>
                      </td>
                      <td>
                        <div className="flex items-center justify-between">
                          <div className="flex gap-[1px] max-w-[160px]">
                            <div className="truncateWrapper">
                              {
                                index % 3 ?
                                <p className="text-green-900 text-small truncate">3FDZVJSFgGcpk5iJMfTPTVDgMwopjKfHYqq3PoZkncFsJWDFPLx9BUWWsmrnFQ2H2CmfxA61gMkrcavSdvbGyv2b</p>
                                : <p className="text-small mr-1">Binance2</p> 
                              }
                            </div>
                            <button className="text-gray-700 dark:text-gray-300"><IoIosCopy /></button>
                          </div>
                          <span className={`badge badge-${index % 3 ? 'success' : 'warning'} w-[32px] justify-center`}>{index % 3 ? 'In' : 'Out'}</span>
                        </div>
                      </td>
                      <td>
                        <div className="flex gap-[1px] max-w-[160px]">
                          <div className="truncateWrapper">
                            {
                              index % 3 !== 1 ?
                              <p className="text-green-900 text-small truncate">3FDZVJSFgGcpk5iJMfTPTVDgMwopjKfHYqq3PoZkncFsJWDFPLx9BUWWsmrnFQ2H2CmfxA61gMkrcavSdvbGyv2b</p>
                              : <p className="text-small mr-1">Binance2</p> 
                            }
                          </div>
                          <button className="text-gray-700 dark:text-gray-300"><IoIosCopy /></button>
                        </div>
                      </td>
                      <td>
                        <p className="text-small">0.000001 BBA</p>
                      </td>
                      <td>
                        <p className="text-small">0.000001 BBA</p>
                      </td>
                    </tr>)
                  }
                  
                </tbody>
              </table>
            </div>
            <div className="p-5 justify-center md:justify-between flex mb-2">
              <div className="md:flex gap-2 hidden">
                <span className="text-small flex items-center">Show</span>
                <select className="text-small">
                  <option>10</option>
                  <option>20</option>
                  <option>50</option>
                  <option>100</option>
                </select>
                <span className="text-small flex items-center">Per Page</span>
              </div>
              <div className="flex gap-2">
                <button className="!px-1.5 !py-1 btn-outline !text-xl disabled"><MdSkipPrevious /></button>
                <button className="!px-1.5 !py-1 btn-outline !text-xl disabled"><MdNavigateBefore /></button>
                <span className="text-small flex items-center px-2">Page 1 of 25</span>
                <button className="!px-1.5 !py-1 btn-outline !text-xl"><MdNavigateNext /></button>
                <button className="!px-1.5 !py-1 btn-outline !text-xl"><MdSkipNext /></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Address;
